<mat-expansion-panel #panSearch class='pasuraMat1 mat-elevation-z4'  style='margin-top:20px; padding-left: 5px'  [expanded]="this.schadenfall==undefined"  (opened)="showSchadenfall=false" >
		<mat-expansion-panel-header>
			<mat-panel-title class="flex-center" >
	  			Suche Schadenfälle
			</mat-panel-title>
			
	 	</mat-expansion-panel-header>
		<div>
	 		<mat-form-field class="flex-center" >
			<!-- <mat-label>Volltext-Suche</mat-label> -->
			<input class="flex-center"  placeholder="Volltext-Suche" matInput [(ngModel)]="SuchText"  name="Suche" type="text">
			<mat-icon class="xonright" (click)="SuchText=''"  >close</mat-icon>
			 
	  		</mat-form-field>
	  		
		</div>
		<button id = "SuchButton" mat-flat-button	color="primary"(click)="sucheSchadenfaelle2($event)" [disabled]="inProgress" style="margin-top:-15px; margin-bottom:20px; width: 50%">Suchen</button>
		
		
		<div layout="row" class="flex-center"  >
		<mat-chip-listbox aria-label="Suchoptionen" [multiple]='true' style="display: block; justify-content: space-between" >
	  		
	  		<mat-chip-option (click)="toggelSuchoptionen(1)" [selected]="Suchoptionen[1]" [selectable]="!Suchoptionen[1]">alle</mat-chip-option>
	  		<mat-chip-option (click)="toggelSuchoptionen(0)" [selected]="Suchoptionen[0]" [selectable]="!Suchoptionen[0]" >neue</mat-chip-option> 
	  		<mat-chip-option (click)="toggelSuchoptionen(4)" [selected]="Suchoptionen[4]" [selectable]="!Suchoptionen[4]">offene</mat-chip-option>
	  		<mat-chip-option (click)="toggelSuchoptionen(2)" [selected]="Suchoptionen[2]" [selectable]="!Suchoptionen[2]">zur Abrechnung</mat-chip-option>
	  		<mat-chip-option (click)="toggelSuchoptionen(3)" [selected]="Suchoptionen[3]" [selectable]="!Suchoptionen[3]">abgerechnete</mat-chip-option>
	  		<!--<mat-chip-option (click)="toggelSuchoptionen(2)" [selected]="Suchoptionen[2]">Police</mat-chip-option>-->
		</mat-chip-listbox>
		</div>
									
		
	
	
		<div >
			<mat-table  *ngIf="schadenfaelle!=undefined " #tableSchadenfaelle [dataSource]='schadenfaelle'>	
			
				<ng-container matColumnDef="FallID">
	   			<mat-header-cell *matHeaderCellDef>Fall-ID</mat-header-cell>
	   			<mat-cell *matCellDef="let element">{{element.FallID}}</mat-cell>
	 			</ng-container>
	 			
				<ng-container matColumnDef="ID">
	   			<mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
	   			<mat-cell *matCellDef="let element">{{element.ID}}</mat-cell>
	 			</ng-container>
	 			
	 			<ng-container matColumnDef="Datum">
	   			<mat-header-cell *matHeaderCellDef>Datum</mat-header-cell>
	   			<mat-cell *matCellDef="let element">{{element.Datum}}</mat-cell>
	 			</ng-container>
	 			
				<ng-container matColumnDef="Schadenfall">
	   			<mat-header-cell *matHeaderCellDef>Meldung</mat-header-cell>
	   			<mat-cell *matCellDef="let element">{{element.Meldung}}</mat-cell>
	 			</ng-container>
	 			
				<ng-container matColumnDef="PolicenNr">
	   			<mat-header-cell *matHeaderCellDef>Policen-Nr</mat-header-cell>
	   			<mat-cell *matCellDef="let element">{{element.PolicenNr}}</mat-cell>
	 			</ng-container>
	 			
	 			<ng-container matColumnDef="Leistung">
	   			<mat-header-cell *matHeaderCellDef>Leistung</mat-header-cell>
	   			<mat-cell *matCellDef="let element">{{globserv.formatMoney(element.Leistung)}}</mat-cell>
	 			</ng-container>  			
	 			
	 			
	 			<ng-container matColumnDef="Halter">
	   			<mat-header-cell *matHeaderCellDef>Halter</mat-header-cell>
	   			<mat-cell *matCellDef="let element">
	   				{{element.TierarztID}} {{element.NameVN}}
	   				</mat-cell>
	 			</ng-container>
	 			
	 			<ng-container matColumnDef="Pferd">
	   			<mat-header-cell *matHeaderCellDef>Pferd</mat-header-cell>
	   			<mat-cell *matCellDef="let element">{{element.NamePferd}}</mat-cell>
	 			</ng-container>
	 			
				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	  			<mat-row 	*matRowDef="let row; columns: displayedColumns" 
	  							class='TabRow'
	  							(click)="selectSchadenfall(row)" 
		 						[ngClass]="{hovered: row.hovered}"
								(mouseover)="row.hovered = true" 
								(mouseout)="row.hovered = false"></mat-row>
	  		</mat-table>		
	  	</div>
</mat-expansion-panel >


<mat-tab-group #tabGroupSchaden class='TabGroup mat-elevation-z4' *ngIf="showSchadenfall" >
	
	<mat-tab *ngIf="meldungVN!=undefined && meldungVN.PolicenNr!=undefined" >
		<div *ngIf='meldungVN!=undefined' class='pasuraMat1 displNormal' class="PasuraSchadenfall" >
			<ng-template mat-tab-label><span>Meldung VN</span></ng-template>
			<app-schadenfall class="AppData" [polDaten]="meldungVN" [PasuraBackOfficeUser]="true">Loading..</app-schadenfall>
		</div>
	</mat-tab >
	
	
	<mat-tab *ngIf="meldungenTA!=undefined" >
		<ng-template mat-tab-label><span>Meldung Tierarzt</span></ng-template>
		
		<mat-card *ngIf='schadenfall!=undefined && schadenfall.TAMeldungFile!=undefined' class='pasuraMat1 displNormal mat-elevation-z4'  >
			<div style="margin-top: 25px; margin-left: 60px; margin-right: 60px; margin-bottom: 30px">
				{{schadenfall.FileName}}
				<br>
				<button  mat-icon-button aria-hidden="true"  (click)="showDocument(schadenfall)">
					<mat-icon>image_search</mat-icon>
				</button> 
			</div>
			
		</mat-card>
		
		<mat-card *ngIf='schadenfall!=undefined && schadenfall.SchadenfallMeldungTA_ID!=undefined' class='pasuraMat1 displNormal mat-elevation-z4'  >
		
			 <div *ngIf="meldungenTA.length>1"  style="display: flex; justify-content: flex-end">
				<button mat-icon-button [disabled]="meldungenTAIDX<=0" (click)="meldungenTAIDX=meldungenTAIDX-1" ><mat-icon>chevron_left</mat-icon></button>
						<span style=" padding-top: 17px" >TA-Meldung {{meldungenTAIDX+1}} von {{meldungenTA.length}}</span>
				<button mat-icon-button [disabled]="meldungenTAIDX>=meldungenTA.length-1" (click)="meldungenTAIDX=meldungenTAIDX+1"><mat-icon>chevron_right</mat-icon></button>
			</div>
				
			<div style="margin-top: 25px; margin-left: 60px; margin-right: 60px;">
			
				<table style="width:800px ">
				
					<tr  >
						<td style="width:25%" >Police-Nr:</td>
						<td style="width:75%" >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.PolicenNr}} </td>
					</tr>
					
					
					<tr *ngIf="meldungenTA[meldungenTAIDX].SchadenfaelleVN==undefined" class="spaceUnder">
						<td  >Schadenfall-Nr:</td>
						<td  >{{meldungenTA[meldungenTAIDX].SchadenfallID}}</td>
					</tr>
					
					
					<tr *ngIf="meldungenTA[meldungenTAIDX].SchadenfaelleVN!=undefined && meldungenTA[meldungenTAIDX].SchadenfaelleVN.length>0 "class="spaceUnder">
						<td >Schadenfall-Nr:</td>
						<td >
							<mat-form-field style="width:80%; margin-right:20px">
								<mat-label>offene Schadenfälle VN</mat-label>
							   	<mat-select placeholder="Schadenfall-VN" [(ngModel)]="meldungenTA[meldungenTAIDX].SchadenfallID"  name="SchadenfallID" (selectionChange)="meldungenTA[meldungenTAIDX].changed=true" >
							    		<mat-option *ngFor="let s of meldungenTA[meldungenTAIDX].SchadenfaelleVN" value="{{s.ID}}">{{s.PreFix}}/{{s.GJ_ID}} {{s.DatumEreignis}}</mat-option>  
							    	</mat-select> 
							</mat-form-field>
							
							<button  (click)="setMeldungTASchadenfall(meldungenTA[meldungenTAIDX])" *ngIf="meldungenTA[meldungenTAIDX].changed !=undefined && meldungenTA[meldungenTAIDX].changed" style="margin-right:20px"><mat-icon  style="color:green">check</mat-icon></button>
							<button  (click)="setMeldungTASchadenfall(meldungenTA[meldungenTAIDX])" *ngIf="meldungenTA[meldungenTAIDX].SchadenfaelleVN!=undefined && meldungenTA[meldungenTAIDX].SchadenfaelleVN.length>0 &&meldungenTA[meldungenTAIDX].SchadenfallID>0"><mat-icon style="color:red">cancel</mat-icon></button>
							
						</td>
					</tr>
					
				
					<tr >
						<td  >Halter:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.halter}}</td>
					</tr>
					
					<tr >
						<td  >Tierarzt:</td>
						<td  >{{meldungenTA[meldungenTAIDX].TierarztID}} {{meldungenTA[meldungenTAIDX].TierarztName}}</td>
					</tr>
					
					<tr class="spaceUnder">
						<td  >Pferd:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.pferd}}</td>
					</tr>
					
					<tr  >
						<td  >Datum:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.datum}}</td>
					</tr>
					
					<tr class="spaceUnder" >
						<td  >Ort:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.ort}}</td>
					</tr>
					
					<tr class="spaceUnder">
						<td  >Art des Schadens:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.art_des_schadens}}</td>
					</tr>
					
					
					<tr class="spaceUnder">
						<td  >Hilfe rechtzeitig:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.hilfe_rechtzeitig}}</td>
					</tr>
					
					<tr class="spaceUnder">
						<td  >In Behandlung seit:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.pferd_in_behandlung_seit}}</td>
					</tr>
					
					<tr class="spaceUnder" >
						<td  >Anamnese:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.anamnese}}</td>
					</tr>
					
					<tr class="spaceUnder">
						<td  >Symptome:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.krankheitssymptome}}</td>
					</tr>
					
					<tr class="spaceUnder">
						<td  >Diagnose:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.diagnose}}</td>
					</tr>
					
					<tr class="spaceUnder">
						<td  >Prognose:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.prognose}}</td>
					</tr>
					
					<tr class="spaceUnder">
						<td  >Massnahmen:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.getroffene_massnahmen}}</td>
					</tr>
					
					<tr class="spaceUnder">
						<td  >Behandlung:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.getroffene_behandlung}}</td>
					</tr>
					
					<tr class="spaceUnder">
						<td  >Zusaetzliche Notizen:</td>
						<td  >{{meldungenTA[meldungenTAIDX].Daten.Schadenfall.zusaetzliche_notizen}}</td>
					</tr>
					
					<tr *ngFor="let file of schadenfall.Daten.FileList" >
						<td  >Anhänge:</td>
						<td  (click)="getFile(file.FileID, file.FileName)"  style="cursor:pointer" >{{file.FileName}} </td>
						<td  (click)="getFile(file.FileID, file.FileName)"  style="cursor:pointer" ><mat-icon aria-hidden="false" aria-label="downoad File">save_alt</mat-icon></td>
					</tr>			
					
				</table>
				
				<mat-icon style="cursor: pointer; margin-left:30px" (click)="getPDFSchadenmeldungTA(-1)" aria-hidden="false" aria-label="downoad File">picture_as_pdf</mat-icon>
			</div>
			
			<!--
			<div *ngIf="editLeistung!=undefined"  style="width:800px;margin-top:5px ">
				<app-leistung [daten]="editLeistung" (saveData)="saveLeistung($event)" >Loading..</app-leistung>
			</div>	
		-->
		<!--
			<div *ngIf='schadenfall!=undefined && schadenfall.Daten!=undefined && schadenfall.Daten.Historie ' style="margin-top: 25px; margin-left: 60px; margin-right: 60px;">
				Leistungs-Historie:
				
				<mat-grid-list cols="4" rowHeight="20px"  style="width:800px;margin-top:5px ">
					<ng-container  *ngFor="let h of schadenfall.Daten.Historie;let idx=index ">
						<mat-grid-tile >{{h.TimeStamp}} </mat-grid-tile>
						<mat-grid-tile *ngIf="h.Typ=='Dokument'">{{h.FileName}}</mat-grid-tile>
						<mat-grid-tile *ngIf="h.Typ=='Dokument'">{{h.Beschreibung}}</mat-grid-tile>
						<mat-grid-tile *ngIf="h.Typ=='Dokument'">
							<mat-icon style="cursor: pointer; margin-left:54px" (click)="getFile(h.DocID, h.FileName)" aria-hidden="false" aria-label="downoad File">save_alt</mat-icon>
							<mat-icon style="cursor: pointer; margin-left:30px" (click)="showToasterDelHistorie(idx)">delete</mat-icon>
						</mat-grid-tile>
						
						<mat-grid-tile *ngIf="h.Typ=='Entschaedigung'">	Entschädigung</mat-grid-tile>
						<mat-grid-tile *ngIf="h.Typ=='Entschaedigung'">	{{globserv.formatMoney(h.Total)}}</mat-grid-tile>
						<mat-grid-tile *ngIf="h.Typ=='Entschaedigung'">
							
							<mat-icon style="cursor: pointer" (click)="this.editLeistung=h" >edit</mat-icon>
							<mat-icon style="cursor: pointer; margin-left:30px" (click)="getPDFEntschaedigung(idx)" aria-hidden="false" aria-label="downoad File">save_alt</mat-icon>
							<mat-icon style="cursor: pointer; margin-left:30px" (click)="showToasterDelLeistung(idx)">delete</mat-icon>
						</mat-grid-tile>
						
						
					</ng-container>
				</mat-grid-list>
				
				<div style="margin-top: 25px">
					<input name="Dokument" type="file" class="file-input" accept=".*" (change)="onDocumentSelected($event)" #fileUpload>
					<button mat-flat-button	color="primary"(click)="fileUpload.click()" style="margin-top:10px; width: 100%">Dokument hinzufügen</button>
					<button mat-flat-button	color="primary"(click)="addEntschaedigung()" style="margin-top:10px; width: 100%">Entschädigung hinzufügen</button>
				</div>
			</div>
			-->
			
			
		</mat-card>
		
	</mat-tab>	
	
</mat-tab-group>